import { PropsWithChildren } from 'react';
import { Navigate, Outlet } from 'react-router';
import { ToastContainer, ToastContainerProps } from 'react-toastify';
import { Loader, QueryBoundary } from '@outdoria/ui';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { useMe } from '../../hooks';

import s from './LayoutMain.module.scss';

export const LayoutMain = () => {
  return (
    <QueryBoundary fallback={<Loader />}>
      <LoadAuth>
        <div className={s.layout}>
          <Header />

          <div className={s.layout__main}>
            <Sidebar />

            <div className={s.layout__content}>
              <Outlet />
            </div>
          </div>
        </div>
      </LoadAuth>
      <ToastContainer {...toastOptions} />
    </QueryBoundary>
  );
};

const toastOptions: ToastContainerProps = {
  closeOnClick: true,
  theme: 'dark',
  autoClose: 2500,
  limit: 3,
  style: { fontSize: '16px', fontWeight: 400 },
};

const LoadAuth = ({ children }: PropsWithChildren) => {
  const { isLoggedIn, isAdmin } = useMe();

  if (!isLoggedIn) return <Navigate to="/auth/login" replace={true} />;

  if (!isAdmin) return <Navigate to="/auth/forbidden" replace={true} />;

  return children;
};
